module.exports = __webpack_public_path__ + "img/virus.e56ddc3d.jpg";